import { call, put } from 'redux-saga/effects'

import { ProtocolsService } from 'services'
import { toasts } from 'utils/toasts'

import * as actions from './Protocols.actions'

export function* fetchAll(event) {
  yield put(actions.setLoading({ loading: true }))

  const $certifications = new ProtocolsService()
  const {
    success,
    status,
    data: protocols
  } = yield call(
    $certifications.fetchAll.bind($certifications),
    event.payload.filters
  )

  yield put(actions.setLoading({ loading: false }))

  if (status === 404) {
    return yield put(
      actions.setProtocols({
        protocols: []
      })
    )
  } else if (success) {
    return yield put(actions.setProtocols({ protocols }))
  } else toasts.generalFail()
}

export function* fetchOne(event) {
  yield put(actions.setLoading({ loading: true }))

  const $certifications = new ProtocolsService()
  const { success, status, data } = yield call(
    $certifications.fetchOne.bind($certifications),
    event.payload.id
  )

  if (success) {
    return yield put(actions.editProtocols({ editProtocols: data }))
  } else if (status === 404) {
    return yield put(actions.editProtocols({ editProtocols: null }))
  } else toasts.generalFail()

  yield put(actions.setLoading({ loading: false }))
}

export function* getProtocolsOptions() {
  const $certifications = new ProtocolsService()
  const { success, status, data } = yield call(
    $certifications.options.bind($certifications)
  )

  if (success) {
    return yield put(actions.setProtocolsOptions({ options: data }))
  } else if (status === 404) {
    return yield put(actions.setProtocolsOptions({ options: [] }))
  } else toasts.generalFail()

  yield put(actions.setLoading({ loading: false }))
}

export function* create(action) {
  yield put(actions.setLoading({ loading: true }))

  const { payload } = action

  const $protocols = new ProtocolsService()
  const response = yield call($protocols.create.bind($protocols), payload)

  if (response.success) {
    toasts.created()
    return yield put(
      actions.setCreatedProtocols({ protocolsCreated: response.data })
    )
  } else if (response.data.code === 'DUPLICATED') {
    toasts.duplicated()
    return yield put(actions.setLoading({ loading: false }))
  } else toasts.generalFail()

  yield put(actions.setLoading({ loading: false }))
}

export function* update(action) {
  yield put(actions.setLoading({ loading: true }))

  const { payload } = action

  const $protocols = new ProtocolsService()
  const response = yield call($protocols.update.bind($protocols), payload)

  if (response.success) {
    toasts.created()
    return yield put(
      actions.setUpdatedProtocols({ protocolsUpdated: response.data })
    )
  } else if (response.data.code === 'DUPLICATED') {
    toasts.duplicated()
    return yield put(actions.setLoading({ loading: false }))
  } else toasts.generalFail()

  yield put(actions.setLoading({ loading: false }))
}

export function* deleteProtocol(action) {
  yield put(actions.setLoading({ loading: true }))

  const { payload } = action

  const $protocols = new ProtocolsService()
  const response = yield call($protocols.remove.bind($protocols), payload.id)

  if (response.success) {
    toasts.deleted()
    return yield put(actions.fetchAll())
  } else toasts.generalFail()

  yield put(actions.setLoading({ loading: false }))
}
